<template>
    <div>
        <div v-if="value" class="back-drop"></div>
        <div v-if="value" class="back-drop-modal" style="display: inline-block" ref="modalBackDrop">
            <div class="alert-parent" :class="modalClass">
                <div class="alert" :class="alertClass">
                    <button @click="$emit('input', false)" class="alert__close">
                        x
                    </button>
                    <div class="alert__left-body  alert__body--space-top">
                        <div v-if="modalTitle" class="alert__header  justify-content-start">
                            <h3 class="alert__title">{{ modalTitle }}<small class="section__descr" v-if="modalDescription"><br />{{ modalDescription }}</small></h3>
                        </div>
                        <div>
                            <slot></slot>
                        </div>

                        <div class="alert__actions">
                            <button v-if="cancelButtonLabel" @click="$emit('input', false)" type="button" class="btn  btn--info-outline">{{ cancelButtonLabel }}</button>
                            <button v-if="okButtonLabel" @click="()=>{this.$emit('ok-button-click');this.$emit('okButtonClick')}" type="button" class="btn  btn--info">{{ okButtonLabel }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: Boolean,
            modalTitle: String,
            modalDescription: String,
            cancelButtonLabel: String,
            okButtonLabel: String,
            alertClass: String,
            modalClass: String,
        },
        methods: {
            modalBackDrop( e ) {
                if ( e.target.classList.contains( 'back-drop-modal' ) ) {
                    this.$emit( 'input', false );
                }
            }
        }
    }
</script>

<style scoped>
    .alert-parent {
        position: absolute;
        top: 50%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        max-height: 100%;
    }

    .alert {
        margin: 0;
        background: #ffffff;
    }

    .min-width-500 {
        min-width: 500px !important;
    }

    .back-drop {
        background-color: rgba(0, 0, 0, .5);
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1050;
    }

    .back-drop-modal {
        z-index: 1050;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        min-height: 100%;
        overflow: auto;
    }

    .alert__close {
        top: 20px !important;
        right: 20px !important;
        border: none;
        background-color: transparent;
        opacity: 0.5;
        -webkit-transition: opacity 0.2s ease-in-out;
        transition: opacity 0.2s ease-in-out;
        font-size: 25px;
    }

    .alert__close:hover {
        opacity: 1;
    }
</style>
